import React from "react";
import AutoComplete from "../../../../../../components/form/AutoComplete";
import Input from "../../../../../../components/form/Input";
import IcoInput from "../../../../../../components/form/IcoInput";
import CroField from "../../../generalForm/CroField";
import CroCountry from "../../../generalForm/CroCountry";
import CroMunicipality from "../../../generalForm/CroMunicipality";
import {
  CroAddButton,
  CroRemoveButton,
} from "../../../generalForm/CroIconButtons";
import { fieldsRemove } from "../../../../CroUtils";
import * as V from "../../../../../../utils/formValidation";
import H from "../../../../helpEnum";
import Help from "../../../Help";
import { ItemNumber, useItemHandlers } from "./itemRenumber";

export default ({
  fields,
  disabled,
  noPublicLogged,
  t,
  dos,
  defaultCountry,
  isLogged,
  onICOChange,
  aresErrors,
  versionChangedClass
}) => {
  const { addItem, removeItem } = useItemHandlers(fields);
  return (
    <div className="cro-array-container">
      {fields.map((item, index) => (
        <div key={index} className={`cro-array-item ${versionChangedClass ? versionChangedClass(item) : ""}`}>
          <ItemNumber index={index} />
          {!disabled && fields.length > 1 && (
              <CroRemoveButton onClick={() => removeItem(index)} />
          )}
          <div className="cro-array-item-content">
            <div className="statementForm__arrayGrid">
              <div>
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.identificationNumber`) : ""}
                  title="IČO"
                  name={`${item}.identificationNumber`}
                  component={IcoInput}
                  disabled={disabled}
                  validate={[V.isNumeric]}
                  onICOChange={(val) => onICOChange && onICOChange(index, val)}
                />
                {aresErrors && aresErrors[index] && (
                  <span className="cro-ares-error">{aresErrors[index]}</span>
                )}
              </div>

              <div className="statementForm__arrayFull">
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.subject`) : ""}
                  title="Předmět"
                  name={`${item}.subject`}
                  component={Input}
                  fullWidth
                  multiline
                  disabled={disabled}
                  validate={[V.required]}
                  helpEnum={H[`${t}NPB_SUBJECT`].r}
                  maxlen={1000}
                />
              </div>
              {!dos && (
                <div className="statementForm__arrayFull">
                  <CroField
                    className={versionChangedClass ? versionChangedClass(`${item}.businessMethod`) : ""}
                    title="Způsob"
                    name={`${item}.businessMethod`}
                    component={AutoComplete}
                    fullWidth
                    disabled={disabled}
                    url="/api/ciselniky/vykony-podnikani"
                    validate={[V.required, V.isDictionary]}
                    helpEnum={H[`${t}NPB_METHOD`].r}
                  />
                </div>
              )}
              {dos && (
                <div className="statementForm__arrayFull">
                  <CroField
                    className={versionChangedClass ? versionChangedClass(`${item}.businessMethodDeputyOrSenator`) : ""}
                    title="Způsob"
                    name={`${item}.businessMethodDeputyOrSenator`}
                    component={AutoComplete}
                    fullWidth
                    disabled={disabled}
                    url="/api/ciselniky/vykony-podnikani-poslanci"
                    validate={[V.required, V.isDictionary]}
                    helpEnum={H[`${t}NPB_METHOD`].r}
                  />
                </div>
              )}

              <p className="statementForm__arrayLabel">
                Místo výkonu podnikání nebo provozování jiné samostatné
                výdělečné činnosti <Help helpEnum={H[`${t}NPB_PLACE`].r} />
              </p>

              {isLogged && (
                <CroCountry
                  className={versionChangedClass ? versionChangedClass(`${item}.address.country`) : ""}
                  title="Stát"
                  name={`${item}.address`}
                  disabled={disabled}
                  form="statementForm"
                  validate={[V.required]}
                  defaultCountry={defaultCountry}
                />
              )}
              {isLogged && (
                <CroMunicipality
                  className={versionChangedClass ? versionChangedClass(`${item}.address.municipality`) : ""}
                  title="Obec"
                  name={`${item}.address`}
                  disabled={disabled}
                  form="statementForm"
                  validate={[V.required]}
                />
              )}

              {isLogged && (
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.address.street`) : ""}
                  title="Ulice"
                  name={`${item}.address.street`}
                  component={Input}
                  disabled={disabled}
                  validate={[V.required]}
                />
              )}
              {isLogged && (
                <CroField
                  className={versionChangedClass ? versionChangedClass(`${item}.address.orientationNumber`) : ""}
                  title="Č.p./Č.o."
                  name={`${item}.address.orientationNumber`}
                  component={Input}
                  disabled={disabled}
                  validate={[V.required]}
                  helpEnum={H.HOUSE_NUMBER.r}
                />
              )}

              {isLogged && (
                <CroField 
                  className={versionChangedClass ? versionChangedClass(`${item}.address.zip`) : ""}
                  title="PSČ"
                  name={`${item}.address.zip`}
                  component={Input}
                  disabled={disabled}
                  validate={[V.required]}
                />
              )}

              {noPublicLogged && (
                <div className="statementForm__arrayFull">
                  <CroField
                    className={versionChangedClass ? versionChangedClass(`${item}.note`) : ""}
                    title="Poznámka"
                    name={`${item}.note`}
                    component={Input}
                    disabled={disabled}
                    multiline
                    helpEnum={H[`${t}NPB_NOTE`].r}
                    maxlen={1000}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
      {!disabled && (
        <div className="cro-array-add">
          <CroAddButton onClick={() => addItem()} />
          <Help helpEnum={H.ADD_REMOVE_BUSSINESS.r} />
        </div>
      )}
    </div>
  );
};
